import { useTranslation } from "react-i18next";
import "./CarouselArtists.scss";

interface CarouselArtistsProps {
  badge?: string;
  title: string;
  subtitle: string;
  description: string;
  buttonText?: string;
  imageUrl: string;
  highlighted?: boolean;
}

const CarouselArtists = ({
  badge,
  title,
  subtitle,
  description,
  buttonText,
  imageUrl,
  highlighted = false,
}: CarouselArtistsProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div id="artists-gradient-card">
      <span
        className={`artist-card-border${
          highlighted ? " artist-card-border--premium" : ""
        }`}
      >
        <div className="card-content">
          <div className="artist-info">
            {badge && <span className="badge">{badge}</span>}
            <span>
              <h2 className="title">{title}</h2>
              <p className="subtitle">{subtitle}</p>

              <p className="description">{description}</p>
            </span>
            <button className="learn-more-btn">
              {t(buttonText || "pages.Pricing.carousel.learnMore")}
            </button>
          </div>
          <div className="artist-image">
            <img src={imageUrl} alt={title} />
          </div>
        </div>
      </span>
    </div>
  );
};

export default CarouselArtists;
